import { State, Selector, Action, StateContext } from "@ngxs/store";
import {
  AddColumnDefinition,
  RemoveColumnDefinition,
} from "../actions/columnDefinition.action";
import { DataColumn } from "../../models/ColumnDefintion";

export class ColumnDefinitionStateModel {
  colDef: DataColumn[];
}

@State({
  name: "colDef",
  defaults: {
    colDef: undefined,
  },
})
export class ColumnDefinitionState {
  @Selector()
  getColumnDefinition(state: ColumnDefinitionStateModel) {
    return state.colDef;
  }

  @Action(AddColumnDefinition)
  add(
    { patchState }: StateContext<ColumnDefinitionStateModel>,
    { payload }: AddColumnDefinition
  ) {
    patchState({ colDef: payload });
  }

  @Action(RemoveColumnDefinition)
  remove({ patchState }: StateContext<ColumnDefinitionStateModel>): void {
    patchState({ colDef: undefined });
  }
}
